import { render } from "./ViewMyFingerspotRecords.vue?vue&type=template&id=1645a8ce&scoped=true"
import script from "./ViewMyFingerspotRecords.vue?vue&type=script&lang=js"
export * from "./ViewMyFingerspotRecords.vue?vue&type=script&lang=js"

import "./fingerspot-attendance.scss?vue&type=style&index=0&id=1645a8ce&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1645a8ce"]])

export default __exports__